module.exports = __webpack_public_path__ + "img/SOC.7c05dbab.svg";